import './Button.scss';

interface ButtonProps {
  label: string;
  onClickCallback?: () => void;
  variant?: 'primary' | 'secondary' | 'cancel' | 'add';
  disabled?: boolean;
  className?: string;
}

export const Button = ({
  label,
  onClickCallback,
  variant = 'primary',
  disabled = false,
  className = '',
}: ButtonProps) => {
  const handleClick = () => {
    if (disabled) return;
    if (onClickCallback) {
      onClickCallback();
    }
  };

  const renderLabel = () => {
    if (variant === 'add') {
      return `+ ${label}`;
    }
    return label;
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`btn button button--${variant} ${className}`}
    >
      {renderLabel()}
    </button>
  );
};

export default Button;
